import React, { Component } from 'react'
import eCharts from 'echarts/lib/echarts'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/title'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import './member.css'
import { post } from '../../ajax/tools'
import PopUp from '../round/PopUp'

class ECharts extends Component {
  constructor(props) {
    super(props)
    this.state = {
      StartTime: '', //开始时间
      EndTime: '', //结束时间
      YCItemName: '', //科目名称
      YCItemId: '', //科目名称
      TheStuId: '',
      YCSchoolType: '',
      YCSchoolId: '',
    }
    // 保存图表实例
    this.chartInstances = {}
    // 缓存上次请求的参数
    this.lastRequestParams = null
    // 防抖定时器
    this.debounceTimer = null
  }

  // 初始化所有图表容器
  initChartContainers = () => {
    const chartIds = [
      'LineEChartsMain',
      'PieEChartsMain',
      'LineEChartsOne',
      'LineEChartsTwo',
      'LineEChartsThree',
    ]

    chartIds.forEach((id) => {
      const dom = document.getElementById(id)
      if (dom) {
        // 如果已有实例，先销毁
        if (this.chartInstances[id]) {
          this.chartInstances[id].dispose()
        }
        // 创建新实例
        this.chartInstances[id] = eCharts.init(dom)
      }
    })
  }

  // 销毁所有图表实例
  destroyCharts = () => {
    Object.values(this.chartInstances).forEach((instance) => {
      if (instance) {
        instance.dispose()
      }
    })
    this.chartInstances = {}
  }

  // 检查参数是否相同
  isParamsSame = (params1, params2) => {
    if (!params1 || !params2) return false
    return (
      params1.StartTime === params2.StartTime &&
      params1.EndTime === params2.EndTime &&
      params1.YCItemId === params2.YCItemId &&
      params1.TheStuId === params2.TheStuId &&
      params1.YCSchoolType === params2.YCSchoolType
    )
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    let history = nextProps
    let StartTime = history.SelectInfo.StartTime
    let EndTime = history.SelectInfo.EndTime
    let YCItemId = history.SelectInfo.YCItemId
    let YCItemName = history.SelectInfo.YCItemName
    let TheStuId = history.SelectInfo.TheStuId
    let YCSchoolType = history.SelectInfo.YCSchoolType
    let YCSchoolId = history.SelectInfo.YCSchoolId

    const newParams = { StartTime, EndTime, YCItemId, TheStuId, YCSchoolType }

    // 如果参数相同，不重新请求
    if (this.isParamsSame(this.lastRequestParams, newParams)) {
      console.log('参数相同，跳过请求')
      return
    }

    // 清除之前的定时器
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer)
    }

    // 设置防抖，300ms内多次触发只执行最后一次
    this.debounceTimer = setTimeout(() => {
      this.setState(
        {
          StartTime: StartTime,
          EndTime: EndTime,
          YCItemId: YCItemId,
          YCItemName: YCItemName,
          TheStuId: TheStuId,
          YCSchoolType: YCSchoolType,
          YCSchoolId: YCSchoolId,
        },
        () => {
          // 保存本次请求参数
          this.lastRequestParams = newParams
          // 在状态更新后，再获取数据并渲染图表
          this.fetchChartData()
        }
      )
    }, 300)
  }

  // 抽取获取数据的方法
  fetchChartData = () => {
    const { StartTime, EndTime, YCItemId, TheStuId, YCSchoolType, YCItemName } =
      this.state

    // 先初始化图表容器
    this.initChartContainers()

    // 第一个请求：饼图
    post({
      url: 'cloudprogram/stu_score_analy_ber_org_mode',
      data: {
        item_id: YCItemId,
        start_time: StartTime,
        end_time: EndTime,
        stu_id: TheStuId,
        type: YCSchoolType,
      },
    }).then((res) => {
      if (res.errno === '200') {
        const myPieChart = this.chartInstances['PieEChartsMain']
        if (myPieChart) {
          myPieChart.setOption({
            title: {
              text: YCItemName + '训练情况统计',
              left: 'center',
              subtext: res.start_time + ' ~ ' + res.end_time,
              subtextStyle: {
                color: '#B03A5B',
              },
            },
            legend: {
              orient: 'vertical',
              left: 'left',
              data: ['坠机率', '超时率', '成功率'],
              selectedMode: false,
              textStyle: {
                color: '#000000',
                fontFamily: 'bold',
                fontSize: 14,
              },
            },
            tooltip: {
              trigger: 'item',
              formatter: '{a} <br/>{b} : {c} ({d}%)',
            },
            series: [
              {
                name: '概率统计',
                type: 'pie',
                radius: '55%',
                center: ['50%', '60%'],
                data: [
                  {
                    value: res.data[0]?.crashNum || 0,
                    name: '坠机率',
                    itemStyle: { color: '#C23531' },
                  },
                  {
                    value: res.data[0]?.overtimeNum || 0,
                    name: '超时率',
                    itemStyle: { color: '#CA8622' },
                  },
                  {
                    value: res.data[0]?.passNum || 0,
                    name: '成功率',
                    itemStyle: { color: '#91C7AE' },
                  },
                ],
                emphasis: {
                  itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)',
                  },
                },
              },
            ],
          })
        }
      } else if (res.errno === '4502') {
        this.props.EChartsBackChild('Login')
      } else {
        this.props.EChartsBackChild('Err')
      }
    })

    // 第二个请求：主折线图
    post({
      url: 'cloudprogram/stu_score_analy_chart_ber_org_mode',
      data: {
        item_id: YCItemId,
        start_time: StartTime,
        end_time: EndTime,
        stu_id: TheStuId,
        type: YCSchoolType,
      },
    }).then((res) => {
      if (res.errno === '200') {
        const myLineChart = this.chartInstances['LineEChartsMain']
        if (myLineChart) {
          const crashNum = []
          const overtimeNum = []
          const passNum = []
          const timeX = []
          for (let i = 0; i < res.data.length; i++) {
            const ItemList = res.data[i]
            crashNum.push(ItemList.crashNum || 0)
            overtimeNum.push(ItemList.overtimeNum || 0)
            passNum.push(ItemList.passNum || 0)
            timeX.push(ItemList.xtime?.substring(5) || '')
          }
          myLineChart.setOption({
            title: {
              text: YCItemName + '训练数据统计',
              left: 'left',
              subtext: res.start_time + ' ~ ' + res.end_time,
              subtextStyle: {
                color: '#B03A5B',
              },
            },
            legend: {
              data: ['坠机次数', '超时次数', '成功次数'],
              left: 'right',
              selectedMode: false,
              textStyle: {
                color: '#000000',
                fontFamily: 'bold',
                fontSize: 14,
              },
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true,
            },
            tooltip: {
              trigger: 'axis',
            },
            xAxis: {
              type: 'category',
              boundaryGap: true,
              data: timeX,
            },
            yAxis: {
              type: 'value',
              axisLabel: {
                formatter: '{value} 次',
              },
            },
            series: [
              {
                name: '坠机次数',
                type: 'line',
                color: '#C23531',
                data: crashNum,
              },
              {
                name: '超时次数',
                type: 'line',
                color: '#CA8622',
                data: overtimeNum,
              },
              {
                name: '成功次数',
                type: 'line',
                color: '#91C7AE',
                data: passNum,
              },
            ],
          })
        }
      } else if (res.errno === '4502') {
        this.props.EChartsBackChild('Login')
      } else {
        this.props.EChartsBackChild('Err')
      }
    })

    // 第三个请求：其他三个折线图
    post({
      url: 'cloudprogram/stu_score_analy_chart_ber_day_org_mode',
      data: {
        item_id: YCItemId,
        start_time: StartTime,
        end_time: EndTime,
        stu_id: TheStuId,
        type: YCSchoolType,
      },
    }).then((res) => {
      if (res.errno === '200') {
        const chartOne = this.chartInstances['LineEChartsOne']
        const chartTwo = this.chartInstances['LineEChartsTwo']
        const chartThree = this.chartInstances['LineEChartsThree']

        let bestScore = []
        let dfl = []
        let totalNum = []
        let timeX = []

        for (let i = 0; i < res.data.length; i++) {
          let ItemList = res.data[i]
          bestScore.push(ItemList.bast_score || 0)
          dfl.push((ItemList.dfl || 0) * 100)
          totalNum.push(ItemList.total_num || 0)
          timeX.push(ItemList.xtime?.substring(5) || '')
        }

        if (chartOne) {
          chartOne.setOption({
            title: {
              text: YCItemName + '训练最好成绩',
              left: 'left',
              subtext: res.start_time + ' ~ ' + res.end_time,
              subtextStyle: { color: '#B03A5B' },
            },
            legend: {
              data: ['最好成绩'],
              left: 'right',
              selectedMode: false,
              textStyle: { color: '#000000', fontFamily: 'bold', fontSize: 14 },
            },
            grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
            tooltip: { trigger: 'axis' },
            xAxis: {
              type: 'category',
              boundaryGap: true,
              data: timeX,
            },
            yAxis: {
              type: 'value',
              axisLabel: { formatter: '{value} 分' },
            },
            series: [
              {
                name: '最好成绩',
                type: 'line',
                color: '#C23531',
                data: bestScore,
              },
            ],
          })
        }

        if (chartTwo) {
          chartTwo.setOption({
            title: {
              text: YCItemName + '训练得分率',
              left: 'left',
              subtext: res.start_time + ' ~ ' + res.end_time,
              subtextStyle: { color: '#B03A5B' },
            },
            legend: {
              data: ['得分率'],
              left: 'right',
              selectedMode: false,
              textStyle: { color: '#000000', fontFamily: 'bold', fontSize: 14 },
            },
            grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
            tooltip: { trigger: 'axis' },
            xAxis: {
              type: 'category',
              boundaryGap: true,
              data: timeX,
            },
            yAxis: {
              type: 'value',
              axisLabel: { formatter: '{value} %' },
            },
            series: [
              {
                name: '得分率',
                type: 'line',
                color: '#C23531',
                data: dfl,
              },
            ],
          })
        }

        if (chartThree) {
          chartThree.setOption({
            title: {
              text: YCItemName + '训练飞行次数',
              left: 'left',
              subtext: res.start_time + ' ~ ' + res.end_time,
              subtextStyle: { color: '#B03A5B' },
            },
            legend: {
              data: ['飞行次数'],
              left: 'right',
              selectedMode: false,
              textStyle: { color: '#000000', fontFamily: 'bold', fontSize: 14 },
            },
            grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
            tooltip: { trigger: 'axis' },
            xAxis: {
              type: 'category',
              boundaryGap: true,
              data: timeX,
            },
            yAxis: {
              type: 'value',
              axisLabel: { formatter: '{value} 次' },
            },
            series: [
              {
                name: '飞行次数',
                type: 'line',
                color: '#C23531',
                data: totalNum,
              },
            ],
          })
        }
      } else if (res.errno === '4502') {
        this.props.EChartsBackChild('Login')
      } else {
        this.props.EChartsBackChild('Err')
      }
    })
  }

  componentDidMount = function () {
    let history = this.props
    let StartTime = history.SelectInfo.StartTime
    let EndTime = history.SelectInfo.EndTime
    let YCItemId = history.SelectInfo.YCItemId
    let YCItemName = history.SelectInfo.YCItemName
    let TheStuId = history.SelectInfo.TheStuId
    let YCSchoolType = history.SelectInfo.YCSchoolType
    let YCSchoolId = history.SelectInfo.YCSchoolId

    const newParams = { StartTime, EndTime, YCItemId, TheStuId, YCSchoolType }
    this.lastRequestParams = newParams

    this.setState(
      {
        StartTime: StartTime,
        EndTime: EndTime,
        YCItemId: YCItemId,
        YCItemName: YCItemName,
        TheStuId: TheStuId,
        YCSchoolType: YCSchoolType,
        YCSchoolId: YCSchoolId,
      },
      () => {
        // 组件挂载后获取数据
        this.fetchChartData()
      }
    )
  }

  AllClick = () => {
    this.setState({})
  }

  componentWillUnmount = () => {
    // 清除定时器
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer)
    }
    this.destroyCharts()
    this.setState = () => {}
  }

  //提示弹窗
  ChildBackTip = (event) => {
    if (event === 'CrossOut') {
      this.setState({
        PopUp: '',
      })
    }
  }

  render() {
    return (
      <div className={'EChartsBox'}>
        <div
          id={'PieEChartsMain'}
          style={{ width: '100%', height: '400px' }}
        ></div>
        <div
          id={'LineEChartsMain'}
          style={{ width: '100%', height: '400px' }}
        ></div>
        <div
          id={'LineEChartsOne'}
          style={{ width: '100%', height: '400px' }}
        ></div>
        <div
          id={'LineEChartsTwo'}
          style={{ width: '100%', height: '400px' }}
        ></div>
        <div
          id={'LineEChartsThree'}
          style={{ width: '100%', height: '400px' }}
        ></div>
        {this.state.PopUp === '提示弹窗' && (
          <PopUp
            ChildBackClick={this.ChildBackTip.bind(this)}
            type={'提示'}
            message={this.state.MessageTip}
            OutButton={'Yes'}
          />
        )}
      </div>
    )
  }
}

export default ECharts
